import { render, staticRenderFns } from "./practice_copy.vue?vue&type=template&id=26bb8d76&scoped=true&"
import script from "./practice_copy.vue?vue&type=script&lang=js&"
export * from "./practice_copy.vue?vue&type=script&lang=js&"
import style0 from "./practice_copy.vue?vue&type=style&index=0&id=26bb8d76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bb8d76",
  null
  
)

export default component.exports